import { z } from 'zod';
import { SLEEP_LOCATIONS } from '../constants.ts';

export const sleepLocationSchema = z.enum(SLEEP_LOCATIONS);

export const sleepStartSchema = z.object({
  location: sleepLocationSchema.optional(),
  started_at: z.number().int().optional(),
});

export const sleepStopSchema = z.object({
  ended_at: z.number().int().optional(),
});

export const sleepCreateSchema = z.object({
  started_at: z.number().int(),
  ended_at: z.number().int().nullable().optional(),
  location: sleepLocationSchema.nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});

export const sleepPatchSchema = z.object({
  started_at: z.number().int().optional(),
  ended_at: z.number().int().nullable().optional(),
  location: sleepLocationSchema.nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
});

export type SleepStartInput = z.infer<typeof sleepStartSchema>;
export type SleepCreateInput = z.infer<typeof sleepCreateSchema>;
export type SleepPatchInput = z.infer<typeof sleepPatchSchema>;
